import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";

class SetupAverageRpm extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            editMode: false,
            inputError: [],
            inputParams: {
                rpm: props.companies.currentCompany.machine_rpm,
            },
            cancelParams: {
                rpm: props.companies.currentCompany.machine_rpm,
            }
        };

        this.translate = this.props.baseData.translate;

        this.updateRpm = this.updateRpm.bind(this);

    }

    componentWillMount() {

        this.updateRpm();

    }

    componentWillReceiveProps(nextProps) {

        this.updateRpm();

    }

    updateRpm() {

        const params = {
            companyId: this.props.companies.currentCompany.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    editMode: false,
                    inputParams: {
                        rpm: res,
                    },
                    cancelParams: {
                        rpm: res,
                    }
                });
            }
        }.bind(this);

        this.api.request('GetRpm', params, callback, null);

    }

    editInput(event, key) {

        const newInput = {...this.state.inputParams};

        newInput[key] = event.target.value;

        this.setState({
            inputParams: newInput
        });

    }

    toggleMode() {

        if (this.state.editMode) this.setState({inputParams: {...this.state.cancelParams}});

        this.setState({
            editMode: !this.state.editMode,
            inputError: [],
        });

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            const errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    enterSaveSettings(event) {

        if (event.keyCode === 13) {
            this.saveSettings();
        } else if (event.keyCode === 27) {
            this.toggleMode();
        }

    }

    saveSettings() {

        const inputFields = this.state.inputParams;
        const rpm = parseInt(inputFields.rpm, 10);

        if (!rpm) return null;

        if (this.props.baseData.saveSettings) this.props.baseData.saveSettings('rpm', rpm);

        this.updateRpm();

    }

    getButtons() {

        if (this.state.editMode) {
            return (
                <span>
                    <a className="formButton" onClick={() => this.toggleMode()} onKeyDown={(event) => this.enterToggleMode(event)}>
                        {this.translate('cancel')}
                    </a>

                    <a className="formButton" onClick={() => this.saveSettings()} onKeyDown={(event) => this.enterSaveSettings(event)}>
                        {this.translate('save')}
                    </a>
                </span>
            );
        } else {
            return (
                <span>
                    <a className="formButton" onClick={() => this.toggleMode()} onKeyDown={(event) => this.enterToggleMode(event)}>
                        {this.translate('edit')}
                    </a>
                </span>
            );
        }

    }

    render() {

        const buttons = this.getButtons();

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('setupHeader1')}</h1>
                </nav>

                <div>
                    <p>{this.translate('setupText1')}</p>
                </div>

                <div className="formRow">
                    <table>
                        <tbody>
                            <tr>
                                <td className="text-left labelSpan">{this.translate('rpm')}</td>

                                <td className="text-left">
                                    <input name="rpm"
                                           className={this.checkInputError('rpm')}
                                           type="number"
                                           step="1"
                                           value={this.state.inputParams.rpm}
                                           disabled={!this.state.editMode}
                                           onChange={(event) => this.editInput(event, 'rpm')}
                                           onKeyDown={(event) => this.enterSaveSettings(event)}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">&nbsp;</td>

                                <td className="text-left">
                                    {buttons}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

    }

}

export default SetupAverageRpm;